import React from 'react'

const UniversityCourses = () => {
  return (
    <div>
      University Courses
    </div>
  )
}

export default UniversityCourses
